import { useCacheSlice } from '../hooks'
import type { AdminPermissions } from '@/shared/config/adminPermissions'

export type AuthSliceData = {
  userId: string
  email: string
  firstName: string | null
  lastName: string | null
  displayName: string
  initials: string
  isAdmin: boolean
  adminPermissions: AdminPermissions
}

export function useAuthCache() {
  const { data, isLoading } = useCacheSlice('auth')
  return { auth: data as AuthSliceData, isAuthLoading: isLoading }
}
